import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import React from 'react';

import type { AuthFooterLinkProps } from './AuthFooterLink.types';

import { TextLink } from '@/components/ui';

/** The chevron sits on the text's centre line. */
const LINK_LAYOUT = 'inline-flex items-center gap-1.5';

/**
 * The ruled-off link at the foot of an auth card: back to log in from the
 * password-recovery cards, on to Dō from an emailed link's page, signing out
 * from the unverified gate. A `TextLink`, with its muted `lead`, if any.
 */
export function AuthFooterLink(props: AuthFooterLinkProps): React.JSX.Element {
  const { lead, back = false, children } = props;
  const content = (
    <>
      {back ? (
        <ChevronLeftIcon className="h-3.5 w-3.5" aria-hidden="true" />
      ) : null}
      {children}
    </>
  );

  return (
    <p className="mt-6 border-t border-stroke-subtle pt-5 text-center text-body-sm text-neutral-500">
      {props.to !== undefined ? (
        <TextLink lead={lead} to={props.to} className={LINK_LAYOUT}>
          {content}
        </TextLink>
      ) : (
        <TextLink lead={lead} onClick={props.onClick} className={LINK_LAYOUT}>
          {content}
        </TextLink>
      )}
    </p>
  );
}

export default AuthFooterLink;
